import { AlignmentType, BorderStyle, Paragraph, ShadingType, Table, TableCell, TableLayoutType, TableRow, TextRun, VerticalAlign, WidthType } from "docx";

export const auditTools = new Paragraph({
    spacing: { before: 250, after: 250 },
    children: [
        new TextRun({
            text: "Descriptions of audit tools:",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})


export const appendicesTable = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    layout: TableLayoutType.FIXED,
    spacing: { before: 600 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 10, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Sl No.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    width: { size: 15, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Tools",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    width: { size: 40, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Description",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    width: { size: 35, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Reference",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "1.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Burp Suite",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.LEFT,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Burp Suite is a Java based Web Penetration Testing framework that has become an industry standard suite of tools used by information security professionals. Burp Suite helps to identify vulnerabilities and verify attack vectors that are affecting web applications.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "https://portswigger.net/",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "2.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Nuclei",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.LEFT,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Nuclei is an open-source tool designed for the detection and scanning of vulnerabilities in web applications and websites. It was developed by Project Discovery and is used to automate the process of web application security scanning and identification of potential security issues",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "https://projectdiscovery.io/nuclei",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "3.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Nikto",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.LEFT,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Nikto is a free software command-line vulnerability scanner that scans web servers for dangerous files/CGIs, outdated server software and other problems",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "https://cirt.net/Nikto2",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "4.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Kali Linux",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.LEFT,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Kali Linux is an open-source, Debian-based Linux distribution aimed at advanced Penetration Testing and Security Auditing",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "https://www.kali.org",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),
    ]
})
